import type { SiteSettings } from './cms-types';

/**
 * Fallback site settings used when Supabase is unreachable or hasn't seeded
 * site_settings yet. Mirrors the seed row in 0002_tables.sql so the marketing
 * site renders correctly even with an empty database.
 */
export const siteSettingsDefault: SiteSettings = {
  brand: {
    name: 'Vonlof',
    legal_name: 'Vonlof',
    tagline: 'Building Digital Solutions for Real-World Problems.',
    logo_url: null,
    wordmark_url: null,
    favicon_url: null,
  },
  contact: {
    email: 'no-reply@vonlof.co',
    phone: '+233 20 558 1981',
    address_line: 'Accra, Ghana',
    business_hours: 'Mon–Fri 09:00–18:00 GMT',
  },
  social: {
    linkedin: null,
    github: null,
    x: null,
    youtube: null,
    instagram: null,
    tiktok: null,
    facebook: null,
  },
  emails: {
    press: 'press@vonlof.co',
    careers: 'careers@vonlof.co',
    accessibility: 'accessibility@vonlof.co',
    security: 'security@vonlof.co',
  },
  theme: { default: 'dark', gold_primary: '#C9A227', bg: '#0B0B0D' },
  nav: {
    primary: [
      { label: 'Home', href: '/' },
      { label: 'Projects', href: '/projects' },
      { label: 'Services', href: '/services' },
      { label: 'Team', href: '/team' },
      { label: 'Contents', href: '/contents' },
      { label: 'Blog', href: '/blog' },
      { label: 'Careers', href: '/careers' },
      { label: 'About', href: '/about' },
    ],
    cta_label: 'Get in touch',
    cta_href: '/contact',
  },
  footer: {
    copyright: `© ${new Date().getFullYear()} Vonlof · Built in Ghana 🇬🇭`,
  },
  seo: {
    default_title_suffix: ' — Vonlof',
    default_description:
      'Vonlof is a Ghana-based software studio designing and engineering products for ambitious teams across Africa — and the world.',
    default_og_image_url: null,
    twitter_handle: null,
  },
  analytics: {
    cloudflare_web_analytics_enabled: true,
    sentry_dsn: null,
    plausible_domain: null,
  },
  email_sender: {
    from_name: 'Vonlof',
    from_email: 'no-reply@vonlof.co',
    reply_to: 'contact@vonlof.co',
  },
};